document.addEventListener('DOMContentLoaded', function () {
    function attachValidation() {
        const miniCartCheckbox = document.querySelector('#mini-license-agreement');
        const miniCartCheckoutButton = document.querySelector('.js-cart-btn-checkout');

        if (miniCartCheckbox && miniCartCheckoutButton) {
            miniCartCheckoutButton.addEventListener('click', function (event) {
                if (!miniCartCheckbox.checked) {
                    alert('Please agree to the License Agreement.');
                    event.preventDefault();
                }
            });
        }
    }

    attachValidation();

    // Reattach validation on mini cart updates
    const miniCartContent = document.querySelector('.js-mini-cart-content'); // Adjust selector as needed
    if (miniCartContent) {
        const observer = new MutationObserver(() => {
            attachValidation();
        });

        observer.observe(miniCartContent, { childList: true, subtree: true });
    }
});